import { useOutletContext } from "react-router-dom";
import { AccountData } from "../../../api/Requests";
import styles from "./Plans.module.css";
import CheckoutForm from "../../../components/Subscription/CheckoutForm";
import { useState } from "react";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";

// const proTest = "price_1RHsyaFVm9asnzhtG9uphhjP";
const proAnnualLiveId = "price_1RPQlEJt1vptUN5MJLTfodqC";
const proMonthlyLiveId = "price_1T75htJt1vptUN5MbMdNgC8o";
const proPlusAnnualLiveId = "price_1T77KpJt1vptUN5M74I3yNwZ";

export default function Plans() {
  const accountData = useOutletContext<AccountData>();
  const [showProPlan, setShowProPlan] = useState(false);
  const [showProPlusPlan, setShowProPlusPlan] = useState(false);
  const [enableAnnualPlan, setEnableAnnualPlan] = useState(
    accountData?.account.subscriptionInterval === "year",
  );

  const displayProPlan = () => {
    setShowProPlusPlan(false);
    setShowProPlan(true);
    document.getElementById("paymentContainer")?.scrollIntoView();
  };

  const displayProPlusPlan = () => {
    setShowProPlan(false);
    setShowProPlusPlan(true);
    document.getElementById("paymentContainer")?.scrollIntoView();
  };

  const toggleAnnualPlan = () => {
    setEnableAnnualPlan(current => !current);
    setShowProPlan(false);
  };

  function refreshPage() {
    window.location.reload();
  }

  // TODO: Add a way to cancel subscription
  const isSubscriptionActive =
    accountData?.account.subscriptionStatus === "active";
  const activeStarterSubscription =
    accountData?.account.subscriptionTier === null ||
    accountData?.account.subscriptionTier === "starter";
  const activeProSubscription =
    isSubscriptionActive && accountData?.account.subscriptionTier === "pro";
  const activeProPlusSubscription =
    isSubscriptionActive && accountData?.account.subscriptionTier === "proplus";
  const activeAnnualInterval =
    isSubscriptionActive &&
    accountData?.account.subscriptionInterval === "year";

  return (
    <div className={styles.planPageContainer}>
      <h1>Plans</h1>
      <div className={styles.planPageToggleContainer}>
        <p>*prices in USD</p>
        {!activeAnnualInterval && (
          <>
            <span className={styles.planPageToggle}>
              Toggle for <b>{enableAnnualPlan ? "Monthly" : "Yearly"}</b>
              <button type="button" onClick={() => toggleAnnualPlan()}>
                {enableAnnualPlan ? <BsToggleOn /> : <BsToggleOff />}
              </button>
            </span>
            <i>
              {!enableAnnualPlan && "*Save $20 per year on annual plan"}&nbsp;
            </i>
          </>
        )}
      </div>
      <div className={styles.planCards}>
        <div id={styles.starterPlan} className={styles.planCard}>
          <h2>Starter</h2>
          <div className={styles.planDash} />
          <p className={styles.planPrice}>Free</p>
          <ul className={styles.planFeatures}>
            <li>
              <b>Out of the box ready</b> one-click website
            </li>
            <li>
              <b>Preview and customize webpage</b>
            </li>
            <li>
              <b>Extremely fast and responsive design</b> desktop and mobile
              friendly
            </li>
            <li>
              <b>Publish to everyone</b> (*to customize url you must upgrade
              plan)
            </li>
          </ul>
          <div className={styles.planButtonContainer}>
            {activeStarterSubscription && (
              <div className={styles.activeTitle}>
                <p>Current Plan</p>
              </div>
            )}
          </div>
        </div>
        <div
          className={styles.planCard}
          style={
            showProPlan && !activeProSubscription
              ? { backgroundColor: "#0538af", color: "#fff" }
              : {}
          }
        >
          <h2>Pro</h2>
          <div className={styles.planDash} />
          <p
            className={styles.planPrice}
            style={
              showProPlan && !activeProSubscription
                ? { color: "#fff" }
                : { color: "#0538af" }
            }
          >
            {enableAnnualPlan ? "$100/year" : "$10/month"}
          </p>
          <i>{enableAnnualPlan && "*Save $20 per year on annual plan"}&nbsp;</i>
          <ul className={styles.planFeatures}>
            <p>
              Includes everything from <b>Starter</b> plan and...
            </p>
            <li>
              <b>Domain forwarding</b>: Already own a domain? You can simply
              point it to your easyzilla website. (GoDaddy, Name.com, etc.)
            </li>
            <li>
              <b>Site security</b> SSL Certificate
            </li>
            <li>
              <b>SEO/AI friendly</b> Allow better website search indexing for
              Search Engines (Google) and AI (ChatGPT)
            </li>
          </ul>
          {!activeProPlusSubscription && (
            <div className={styles.planButtonContainer}>
              {activeProSubscription &&
              (activeAnnualInterval ||
                (!activeAnnualInterval && !enableAnnualPlan)) ? (
                <div className={styles.activeTitle}>
                  <p>Subscription Active</p>
                </div>
              ) : (
                <button
                  className={styles.purchaseButton}
                  onClick={() => displayProPlan()}
                >
                  {showProPlan ? "Selected" : "Upgrade"}
                </button>
              )}
            </div>
          )}
        </div>
        <div
          className={styles.planCard}
          style={
            showProPlusPlan && !activeProPlusSubscription
              ? { backgroundColor: "#0538af", color: "#fff" }
              : {}
          }
        >
          <h2>Pro Plus</h2>
          <div className={styles.planDash} />
          <p
            className={styles.planPrice}
            style={
              showProPlusPlan && !activeProPlusSubscription
                ? { color: "#fff" }
                : { color: "#0538af" }
            }
          >
            $200/year
          </p>
          *Only billed annually
          <ul className={styles.planFeatures}>
            <p>
              Includes everything from <b>Pro</b> plan and...
            </p>
            <li>
              <b>Primary domain</b> Pick your own custom domain
            </li>
            <li>
              <b>Webpage analytics</b> Embed Google Analytics Tag for real-time
              webpage insights
            </li>
            <li>
              <b>Pro Plus Support</b> Priority support for general issues or
              questions, web design concerns, site reliability.
            </li>
            <li>No easyzilla Branding</li>
          </ul>
          <div className={styles.planButtonContainer}>
            {activeProPlusSubscription ? (
              <div className={styles.activeTitle}>
                <p>Subscription Active</p>
              </div>
            ) : (
              <button
                className={styles.purchaseButton}
                onClick={() => displayProPlusPlan()}
              >
                {showProPlusPlan ? "Selected" : "Upgrade"}
              </button>
            )}
          </div>
        </div>
      </div>
      <div id="paymentContainer" className={styles.paymentContainer}>
        {showProPlan && (
          <CheckoutForm
            priceId={enableAnnualPlan ? proAnnualLiveId : proMonthlyLiveId}
            isSubscriptionActive={isSubscriptionActive}
          />
        )}
        {showProPlusPlan && (
          <CheckoutForm
            priceId={proPlusAnnualLiveId}
            isSubscriptionActive={isSubscriptionActive}
          />
        )}
        {!showProPlan && !showProPlusPlan && (
          <div className={styles.faqInfo}>
            <h3>FAQ</h3>
            <div className={styles.planDash} />
            <p>
              <b>What system is used to process subscription payments?</b>
            </p>
            <p>
              We use Stripe to process all subscription payments. Stripe is a
              secure and trusted payment processor used by many companies.
            </p>
            <p>
              <b>Can I update my payment information?</b>
            </p>
            <p>
              Please <a href="mailto:hello@easyzilla.com">contact support</a>{" "}
              and we will work with you to update appropriate payment info.
            </p>
            <p>
              <b>How do I cancel my subscription?</b>
            </p>
            <p>
              Please <a href="mailto:hello@easyzilla.com">contact support</a>{" "}
              and we will close out your subscription; no questions asked.
            </p>
            <p>
              <b>Can more of the Plans and Payment flows be self-serve?</b>
            </p>
            <p>
              We are in the process of adding a more streamlined way to handle
              subscription flows. We strive to make life easier, more self-serve
              options are on the way!
            </p>
          </div>
        )}
        <p
          className={styles.paymentHelpInfo}
          style={
            !isSubscriptionActive && showProPlan
              ? { display: "block" }
              : { display: "none" }
          }
        >
          If you are having issues with checkout please{" "}
          <a onClick={() => refreshPage()} href="#top">
            Refresh Page
          </a>{" "}
          or <a href="mailto:hello@easyzilla.com">Contact Support</a>
        </p>
      </div>
    </div>
  );
}
